<div class="switch-menu">
  @if (this.mode == 'side') {
    <span matTooltip="El menú está en modo fijo" (click)="set_menu_storage()" class="gear-icon"><span class="material-symbols-outlined" style="color:#673ab7">toggle_on</span></span>
  }
  @if (this.mode == 'over') {
    <span matTooltip="El menú está en modo oculto" (click)="set_menu_storage()" class="gear-icon"><span class="material-symbols-outlined" style="color:#673ab7">toggle_off</span></span>
  }

</div>

@if (menu_cliente == true) {
  <nav class="animate__animated" style="margin-top: 30px;">
    <ul style="line-height:280%">
      <!--Inicio-->
      <li>
        <a  routerLink="/home">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">home</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Inicio" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Excedentes-->
      <li>
        <a  routerLink="/home/excedentes" routerLinkActive="router-link-active">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">local_offer</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Excedentes" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Facturas Nubox-->
      <li>
        <a  routerLink="/home/facturas-arrayan" routerLinkActive="router-link-active">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">receipt_long</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Facturas Simpli" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Liquidaciones-->
      <li>
        <a  routerLink="/home/liquidaciones" routerLinkActive="router-link-active">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">mail</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Liquidaciones" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Cartola-->
      <li>
        @if (!is_responsive) {
<a routerLink="/home/cartola"  [ngClass]="{'router-link-active': 
            this.router.url == '/home/cartola'}">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <span class="material-symbols-outlined material-simpli">trending_up</span>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                <input value="Cartola" readonly class="sin-input">
              </div>
            </div>
          </a>
        }
        @if (is_responsive) {
<a routerLink="/home/cartola-r"  [ngClass]="{'router-link-active': 
            this.router.url == '/home/cartola'}">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <span class="material-symbols-outlined material-simpli">trending_up</span>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                <input value="Cartola" readonly class="sin-input">
              </div>
            </div>
          </a>
        }
      </li>
      <!--Simulaciones-->
      <li>
        @if (!is_responsive) {
          <a routerLink="/home/simulaciones" routerLinkActive="router-link-active">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <span class="material-symbols-outlined material-simpli">task_alt</span>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                <input value="Simulaciones" readonly class="sin-input">
              </div>
            </div>
          </a>
        }
        @if (is_responsive) {
          <a routerLink="/home/simulaciones-r/{{id_company}}" routerLinkActive="router-link-active">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <span class="material-symbols-outlined material-simpli">task_alt</span>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                <input value="Simulaciones" readonly class="sin-input">
              </div>
            </div>
          </a>
        }
      </li>
      <!--Operaciones-->
      <li>
        <a  id="menu-operaciones" routerLink="/home/operaciones"
            [ngClass]="{'router-link-active': 
            this.router.url == '/home/operaciones-remuneraciones' || 
            this.router.url == '/home/operaciones-proveedores' ||
            this.router.url == '/home/operaciones'  }">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">checklist</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Operaciones" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Pago Proveedores-->
      <li style="display: none;" class="sub-menu special-hover">
        <a  routerLinkActive="router-link-active"
            [ngClass]="{'router-link-active': 
            pagoproveedores.isActive || 
            gestionproveedores.isActive || 
            facturaspagadas.isActive ||
            pagoremuneraciones.isActive }">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">volunteer_activism</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated" style="position: relative;">
              <input value="Payment" readonly class="sin-input">
              <!--(mouseenter)="mouseenter(true)"-->
              <span class="material-symbols-outlined right flecha-desplegable">expand_more</span>
            </div>
          </div>
        </a>
        <ul id="menupagoproveedores" style="line-height:130%;font-size: 14px;">
          <li>
            <a  #pagoproveedores="routerLinkActive"  routerLink="/home/pago-proveedores" routerLinkActive="router-link-active">
              Pago a Proveedores
            </a>
          </li>
          <li>
            <a  #pagoremuneraciones="routerLinkActive"  routerLink="/home/pago-remuneraciones" routerLinkActive="router-link-active">
              Pago de Remuneraciones
            </a>
          </li>
          <li>
            <a  #gestionproveedores="routerLinkActive" routerLink="/home/pago-proveedores-fechas" routerLinkActive="router-link-active">
              Gestión de Proveedores
            </a>
          </li>
          <li>
            <a  #facturaspagadas="routerLinkActive" routerLink="/home/pp-facturas-pagadas" routerLinkActive="router-link-active">
              Facturas pagadas
            </a>
          </li>
        </ul>
      </li>
      <!--Cartera-->
      <li>
        <a  routerLink="/home/detalle-cartera" routerLinkActive="router-link-active">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">account_balance_wallet</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Cartera" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Dashboard-->
      <li>
            <a  routerLink="/home/dashboard"  [ngClass]="{'router-link-active': 
            this.router.url == '/home/dashboard-compras' || this.router.url == '/home/dashboard' }">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">bar_chart</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Dashboard" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--mis movimientos-->
      <li style="display: none">
        <a  routerLink="/home/resumen-linea" (click)="go_to_resumen()">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">bar_chart</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Resumen linea" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
    </ul>
  </nav>
}

@if (menu_confirming_pronto_pago == true) {
  <nav class="animated bounceInDown">
    <ul style="line-height:280%">
      <!--Inicio-->
      <li>
        <a  routerLink="/home/confirming">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">home</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Inicio" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Pago Proveedores-->
      <li>
        <a  routerLink="/home/dashboard" routerLinkActive="router-link-active">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">volunteer_activism</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Payment" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
      <!--Liquidaciones-->
      <li>
        <a  routerLink="/home/liquidaciones" routerLinkActive="router-link-active">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <span class="material-symbols-outlined material-simpli">mail</span>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
              <input value="Liquidaciones" readonly class="sin-input">
            </div>
          </div>
        </a>
      </li>
    </ul>
  </nav>
}